import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
declare let $: any;
@Component({
  selector: 'emiplus-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  IconDown = faCaretDown;
  pathAssets: string;
  loading: boolean = false;
  constructor(private readonly router: Router) {
    this.pathAssets = './../../../assets';
  }

  logOut() {
    this.router.navigate(['/']);
  }
  profileInfo() {
    this.router.navigate(['/profile-information']);
  }


  private hideSpinner() {
    this.loading = false;
  }

  toggleSideBar() {
    $('#sidebar').addClass('active');
    $('.overlay').addClass('active');
    $('.collapse.in').toggleClass('in');
    $('a[aria-expanded=true]').attr('aria-expanded', 'false');
  }

  dismissSideBar() {
    $('#sidebar').removeClass('active');
    $('.overlay').removeClass('active');
  }
}
